import { Component, Input } from '@angular/core';
import { MemberAdmittedComm, MemberAdmittedMa } from '@core/constants/messages';
import { AuthDetailsPac } from '@shared/model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'authorization-details',
    templateUrl: './authorization-details.component.html',
    styleUrls: ['./authorization-details.component.scss'],
    standalone: false
})
export class AuthorizationDetailsComponent {
  @Input() isInternal: boolean;
  @Input() isPacCommercial: boolean;
  @Input() isPASComplete: boolean;

  authState!: AuthDetailsPac;

  clinicalCategory!: string;

  memberAdmittedCommMsg = MemberAdmittedComm;
  memberAdmittedMaMsg = MemberAdmittedMa;

  @Input() set authData(value: AuthDetailsPac) {
    this.authState = value;

    this.clinicalCategory = value?.clinicalCategories
      .map((item) => item.description)
      .join(', ');
  }
}
